import React from 'react'
import LineScale from './LineScale'
import styles from './Loading.module.scss'

const showError = process.env.REACT_APP_SHOW_DEBUG === 'enabled'

const LoadingApp = ({ error }) => (
  <div className={styles.appLoader}>
    {!!error && showError && (
      <div>
        <h1>Awww... Carp!</h1>
        <div>{error.toString()}</div>
      </div>
    )}
    {(!showError || !error) && <LineScale />}
  </div>
)

export default LoadingApp
